import type { CSSProperties } from 'react';

import styles from './vertical-arrows.module.css';

type VerticalArrowsProps = {
  height: number;
  topLabel?: string;
  bottomLabel?: string;
  color?: string;
  fontFamily?: string;
};

/**
 * Up/down text arrows with labels, rendered in a column to the right of a
 * DivergingBarChart. All inputs are plain data so it serializes cleanly into
 * a shared-report snapshot.
 */
export const VerticalArrows = ({
  height,
  topLabel,
  bottomLabel,
  color,
  fontFamily = 'inherit',
}: VerticalArrowsProps) => {
  const centerY = height / 2;
  const style = {
    '--vertical-arrow-color': color,
    '--vertical-arrow-font': fontFamily,
  } as CSSProperties;

  return (
    <div className={styles.container} style={style}>
      {topLabel && (
        <div
          className={`${styles.textGroup} ${styles.textGroupTop}`}
          style={{ bottom: height - centerY }}
        >
          <span aria-hidden="true">↑</span>
          <span>{topLabel}</span>
        </div>
      )}
      {bottomLabel && (
        <div
          className={`${styles.textGroup} ${styles.textGroupBottom}`}
          style={{ top: centerY }}
        >
          <span>{bottomLabel}</span>
          <span aria-hidden="true">↓</span>
        </div>
      )}
    </div>
  );
};
